import { Component, OnInit, Optional, Inject } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'psc-research',
    templateUrl: './psc-research.component.html'
})
export class PscResearchComponent implements OnInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    url: string = '';
    acctRef: any;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                @Optional() @Inject('AppSettings') appSettings: any) {
                //this.url = appSettings.ibdConfigMap.modUrl+ '/F2/site/piperredirect';
                this.url = 'https://secure.psc.com/secure1col.aspx?id=6670';
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
        });
    }
    renderDojoWidget(): void {
        if (dojoApp) {
            dojoApp.getpscsearch(this.url);
        }
    }
    handleresearchLink() {
        this.renderDojoWidget();
    }
}
